﻿import React from 'react';
import {connect} from 'react-redux';

import DynamicFormHelpText from './DynamicFormHelpText';
import DynamicFormSubQuestionGroup from './DynamicFormSubQuestionGroup';
import DynamicFormLevel1QuestionRow from './DynamicFormLevel1QuestionRow';

import {
    QuestionGroup,
    DynamicFormHeading,
    DynamicFormPreamble,
    Level1RowContainer
} from '../Styles/dynamicFormStyles';

class DynamicFormQuestionGroup extends React.PureComponent {
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        const questionGroup = this.props.questionGroup;

        const groupTitle = questionGroup.title;
        const groupPreamble = questionGroup.preamble;
        const groupQuestions = questionGroup.questions;
        const groupSubQuestions = questionGroup.subQuestionGroups;

        return (

            <QuestionGroup>
                <DynamicFormHeading>{groupTitle}</DynamicFormHeading>

                <DynamicFormPreamble>
                    {groupPreamble}
                    <DynamicFormHelpText questionGroupHelpText={this.props.questionGroup.helpText} />
                </DynamicFormPreamble>

                {groupQuestions && groupQuestions.length > 0 &&
                    <Level1RowContainer>
                        {groupQuestions.map(group => (
                            <DynamicFormLevel1QuestionRow
                                key={group.id}
                                questionGroup={group}
                                styleForConfirmView={this.props.currentStep === 1}
                                questionTypeHandler={QuestionTypeHandler}

                                formInputs={this.props.formInputs}
                                repeatedInputs={this.props.repeatedInputs}

                                addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                                removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                                removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}
                                repeatQuestionGroup={this.props.repeatQuestionGroup}
                                removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}
                            />
                        ))}
                    </Level1RowContainer>
                }

                {groupSubQuestions && groupSubQuestions.length > 0 &&
                    groupSubQuestions.map(group => (
                        <DynamicFormSubQuestionGroup
                            key={group.id}
                            questionGroup={group}
                            questionTypeHandler={QuestionTypeHandler}

                            formInputs={this.props.formInputs}
                            repeatedInputs={this.props.repeatedInputs}

                            addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                            removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                            removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}
                            repeatQuestionGroup={this.props.repeatQuestionGroup}
                            removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}
                        />
                    ))
                }
            </QuestionGroup>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentStep: state.pageCurrentStep
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicFormQuestionGroup);
